import { Link } from "react-router-dom";

export default function LinkComponent({
  path,
  title,
  color,
}: {
  color?: string;
  path: string;
  title: string;
}) {
  return (
    <Link style={{ color: color ?? "var(--exhut-total-green)" }} to={path}>
      {title}
    </Link>
  );
}
